import { ConfirmationModal } from './ConfirmationModal'
import { Modal } from 'semantic-ui-react'
import { ProductRemovalStatus } from '../../redux/types/products'

export function RemoveProductModal(props: {
  open: boolean
  setOpen: (value: ((prevState: boolean) => boolean) | boolean) => void
  onConfirm: () => void
  removalStatus: ProductRemovalStatus
  productId: number
}) {
  return (
    <ConfirmationModal open={props.open} setOpen={props.setOpen} onConfirm={props.onConfirm}>
      <Modal.Header>
        {props.removalStatus === null ? 'Proceed with removal?' : 'Cancel removal?'}
      </Modal.Header>
      <Modal.Content>
        {props.removalStatus === null ? (
          <>
            <p>Are you sure you want to initiate the removal of the product #{props.productId}?</p>
            <p>
              It will be removed as soon as it's not available in stores, and finalized removals are
              irreversible.
            </p>
            <p>Pending removals can only be cancelled before they're finalized.</p>
          </>
        ) : (
          <p>
            Are you sure you want to cancel the removal process of the product #{props.productId}?
          </p>
        )}
      </Modal.Content>
    </ConfirmationModal>
  )
}
